@if (document) {
    <div class="ap-file-upload">
        <ap-file-selector
            [acceptedFileExtensions]="document.originalDocument.toegestane_formaten"
            [maxFilesAllowed]="maxFilesAllowed()"
            [uploadPreview]="uploadPreview() && !hidePreview"
            [fileSizeLimitInMB]="document.originalDocument.maximum_grootte"
            [selectedFiles]="document.selectedFiles"
            (filesSelected)="selectFile($event, document)"
            (fileDeleted)="removeFile($event, document)"
            [showHeader]="document?.selectedFiles.length > 0"
            [hideUploadField]="uploadFinished"
            [selectorFormControl]="control()"
            [compact]="compact()"
        >
        </ap-file-selector>
        @if (processing) {
            <div class="ap-file-upload__spinner-container" [class.ap-file-upload__spinner-container--compact]="compact()">
                <div class="ap-file-upload__spinner">
                    <ap-spinner
                        [loadingText]="'file-upload.spinner.message' | apContent"
                        [readyText]="'file-upload.spinner.readyText' | apContent"
                    ></ap-spinner>
                </div>
            </div>
        }
        @if (showRestartButton) {
            <div class="ap-file-upload__undo-button">
                <ap-icon name="undo"></ap-icon>
                <ap-button [text]="true" (onClick)="retryUpload.emit()">{{ 'file-upload.restart.upload' | apContent }}</ap-button>
            </div>
        }
    </div>
}

@if (showSaveButton) {
    <ap-button
        class="ap-file-upload__save-button"
        [isDisabled]="!(document?.selectedFiles?.length && isActionableDocumentState(document))"
        type="button"
        ariaLabel="Opslaan"
        (onClick)="saveFiles(document)"
        data-bb="file-upload-save-button"
    >
        {{ 'file-upload.save' | apContent }}
    </ap-button>
}
